export default __webpack_public_path__ + "static/media/screen-move.cc36a9f3.mp4";